/* eslint-disable react/require-default-props */

/* eslint-disable react/jsx-props-no-spreading */
import { useWindowSize } from '@folklore/hooks';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef } from 'react';

import useKeyboardKeys, { KEYS } from '../../hooks/useKeyboardKeys';

import { useModals } from '../../contexts/ModalsContext';
import CloseButton from '../buttons/Button';
import CloseIcon from '../icons/Close';
import InfoModal from './Info';
import ShareModal from './Share';

import styles from '../../styles/modals/modal.module.css';

const propTypes = {
    page: PropTypes.shape({
        title: PropTypes.string,
    }),
    showClose: PropTypes.bool,
    className: PropTypes.string,
};

const Modal = ({ page = null, showClose = true, className = null }) => {
    const modalRef = useRef(null);
    const { modal = null, setModal } = useModals();

    const { type = null } = modal || {};
    const { height = null } = useWindowSize();

    const onClose = useCallback(() => {
        setModal(null);
    }, [setModal]);

    const onCloseShare = useCallback(() => {
        setModal(null);
    }, [setModal]);

    const hasLoadedModal = modal !== null;
    const visible = modal !== null;

    useEffect(() => {
        if (modal !== null) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [modal]);

    useKeyboardKeys({
        [KEYS.ESCAPE]: onClose,
    });

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.visible]: visible,
                },
            ])}
        >
            <div className={styles.wrapper} ref={modalRef}>
                <div className={styles.inner}>
                    {modal !== null && showClose ? (
                        <CloseButton
                            className={styles.closeBtn}
                            onClick={onCloseShare}
                            color="#fff"
                        >
                            <CloseIcon />
                        </CloseButton>
                    ) : null}
                    {hasLoadedModal ? (
                        <div
                            className={styles.content}
                            style={{ minHeight: height !== null && height > 0 ? height : '100vh' }}
                        >
                            {modal !== null && type === 'info' ? (
                                <InfoModal page={page} {...modal} onClose={onClose} />
                            ) : null}
                            {modal !== null && type === 'share' ? (
                                <ShareModal page={page} {...modal} onClose={onCloseShare} />
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>
            <div className={styles.lightBox} />
        </div>
    );
};

Modal.propTypes = propTypes;

export default Modal;
